module.exports = __webpack_public_path__ + "static/media/back11.d43adc0e.jpg";